export default {
  menu: {
    home: 'Home',
    // Reports group
    reportsSubmenu: 'Reports',
    reportsSubmenuShort: 'Reports',
    endUsersActivity: 'End-Users Activity',
    virtualLiquidityPosition: 'Virtual Liquidity Position',
    endUsersActivityReport: 'Report "End-Users Activity"',
    virtualLiquidityPositionReport: 'Report "Virtual Liquidity Position"',
    partnersReport: 'Report "Partners"',
    tenantAccountsReport: 'Report "Tenant Accounts"',
    // Transactions group
    transactionsSubmenu: 'Transactions',
    headTransactions: 'Transactions',
    deals: 'Deals',
    transfers: 'Transfers',
    batches: 'Batches',
    // Profiles
    individuals: 'Individuals',
    businesses: 'Businesses',
    businessTeamMembers: 'Business Team Members',
    accounts: 'Accounts',
    // Workflows & Approvals
    workflowsAndApprovals: 'Workflows & Approvals',
    workflowsAndApprovalsShort: 'Approvals',
    pendingApprovalCases: 'Pending Approval Cases',
    completedApprovalCases: 'Completed Approval Cases',
    tasklistApp: 'Pending BPM Tasks',
    // Financial Parameters
    financialParameters: 'Financial Parameters',
    financialParametersShort: 'Finance',
    pricing: 'Pricing Tables',
    fxRates: 'FX Rates',
    // Configuration
    configuration: 'Configuration',
    configurationShort: 'Config',
    solutions: 'Solutions',
    paymentServices: 'Payment Services',
    localization: 'Message Templates',
    profileTags: 'Profile Tags',
    currenciesAndFx: 'Currencies and FX',
    pnlAccounts: "Tenant's Accounts",
    liquidityBuckets: 'Liquidity Buckets',
    menu: 'Dynamic Menus',
    appsUpdate: 'Apps Update',
    scripts: 'Scripts',
    // Integrations
    integrations: 'Integrations',
    partners: 'Partners',
    externalProfileLinks: 'Profile Links',
    actionReports: 'Action Reporting',
    ledgers: 'Ledgers',
    mambu: 'Mambu',
    // Credentials
    credentials: 'Credentials',
    credentialsShort: 'Access',
    apiIdentities: 'End-User Identities',
    team: 'Dashboard Identities',
    roles: 'Dashboard Roles',
    // Monitoring
    monitoring: 'Monitoring',
    monitoringShort: 'Monitor',
    events: 'Events',
    auditLog: 'System Log',
    core: 'core',
    dashboard: 'dashboard',
    // Legacy / unused keys kept for compatibility
    accountsSubmenu: 'Accounts',
    reports: 'Reports',
    transactions: 'Transactions',
    currencyConversion: 'Currency conversion',
    actionReporting: 'Action Reporting',
    feedback: 'Feedback',
    applicationRules: 'Apps Update',
    approvalsSubmenu: 'Workflows & Approvals',
    pendingApprovals: 'Pending Approval Cases',
    completedApprovals: 'Completed Approval Cases',
    addOn: 'Add-on',
    new: 'New',
  },
  ChangePasswordModal: {
    _: 'Change password',
    resetPassword: 'Reset password',
    required: 'Required',
    success: 'Password reset email is sent',
    passwordResetWarning:
      'To change password click on "Reset password" button below – password reset email would be sent to your email address. Follow the reset link in that email and set new password.',
  },
  login: {
    privacy: 'Privacy Policy',
    singInTo: 'Sing in to the',
    getDemoAccess: "Don't have an account yet? Get demo access.",
    dontReceiveTheOtp: 'Did not receive the code?',
    resendOtp: 'Resend SMS',
    enterCode: 'Enter code',
    weHaveSentCode: 'We have sent you SMS with verification code (OTP) on',
  },
};
